// extracted by mini-css-extract-plugin
export default {"bgname":"Videos_bgname__V2Njo","team_text":"Videos_team_text__k8AVe","team_wrapper":"Videos_team_wrapper__P8eRV","video_container":"Videos_video_container__APRVU"};